var _g, _g2, _rect, _rect2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyState(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 554,
    height: 292,
    viewBox: "0 0 554 292",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3484_4731)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3484_4731)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 36,
    width: 480,
    height: 216,
    rx: 12,
    fill: "#F6F8F7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 36,
    width: 480,
    height: 36,
    fill: "#F6F8F7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 72,
    width: 480,
    height: 1,
    fill: "#EDF0EF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 54,
    r: 4,
    fill: "#677E72"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 54,
    r: 4,
    fill: "#A7B7AF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 54,
    r: 4,
    fill: "#C7D1CC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.5,
    y: 89.5,
    width: 8,
    height: 8,
    rx: 1.5,
    stroke: "#1B211E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 90,
    width: 200,
    height: 7,
    rx: 3,
    fill: "#A7B7AF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 456,
    y: 90,
    width: 40,
    height: 7,
    rx: 3,
    fill: "#A7B7AF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.5,
    y: 129.5,
    width: 8,
    height: 8,
    rx: 1.5,
    stroke: "#1B211E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 130,
    width: 160,
    height: 7,
    rx: 3,
    fill: "#A7B7AF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 464,
    y: 130,
    width: 32,
    height: 7,
    rx: 3,
    fill: "#A7B7AF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.5,
    y: 169.5,
    width: 8,
    height: 8,
    rx: 1.5,
    stroke: "#1B211E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 170,
    width: 130,
    height: 7,
    rx: 3,
    fill: "#A7B7AF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 468,
    y: 170,
    width: 28,
    height: 7,
    rx: 3,
    fill: "#A7B7AF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.5,
    y: 209.5,
    width: 8,
    height: 8,
    rx: 1.5,
    stroke: "#1B211E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 210,
    width: 100,
    height: 7,
    rx: 3,
    fill: "#A7B7AF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 182,
    width: 480,
    height: 70,
    fill: "url(#paint0_linear_3484_4731)"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 32.5,
    y: 36.5,
    width: 479,
    height: 215,
    rx: 11.5,
    stroke: "#EDF0EF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd_3484_4731)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 512,
    cy: 36,
    r: 22,
    fill: "#E0E6E3"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 504,
    y: 35,
    width: 16,
    height: 2,
    rx: 1,
    fill: "#4A5B52"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 511,
    y: 28,
    width: 2,
    height: 16,
    rx: 1,
    fill: "#4A5B52"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3484_4731",
    x: 0,
    y: 12,
    width: 544,
    height: 280,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3484_4731"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3484_4731",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_3484_4731",
    x: 470,
    y: 0,
    width: 84,
    height: 84,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.823529 0 0 0 0 0.854902 0 0 0 0 0.941176 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3484_4731"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.823529 0 0 0 0 0.854902 0 0 0 0 0.941176 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_3484_4731",
    result: "effect2_dropShadow_3484_4731"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_3484_4731",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3484_4731",
    x1: 272,
    y1: 182,
    x2: 272,
    y2: 252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3484_4731"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 36,
    width: 480,
    height: 216,
    rx: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyState);
export default __webpack_public_path__ + "static/media/empty-state.20c58d215263354c44bb327175aa415d.svg";
export { ForwardRef as ReactComponent };